import apiClient from "../apiClient";
import { CommonApiResponse } from "../../Controllers/Types/ApiResponse";
import { BuildingControlProjectsType } from "../../Controllers/Types/BuildingControl/BuildingControlProjectsType";
import { baseURL } from "../ApiConstant";
import { BuildingControlQuotationResponsePayload } from "../../Controllers/Types/BuildingControl/BuildingControlQuotationType";
import { BuildingControlPermissionPayload } from "../../Controllers/Types/BuildingControl/BuildingControlPermissionType";

// For get all building control projects
export const getAllBuildingControlProjects = async () => {
    try {
        const response = await apiClient.get(`/api/building-control-project-data`);

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        // Handle error (display error message, log, etc.)
        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};

// For Add project to the building control
export const addProjectForBuildingControl = async (projectList: BuildingControlProjectsType[]): Promise<CommonApiResponse> => {
    try {
        // prepare ids for number list
        const list = projectList.map((e) => e.project_id);

        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/building-control-project-add`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: JSON.stringify({ list }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// ---------------------------------------- Building control quotation
// Get Building inspection companies
export const getBuildingInspectionCompanies = async () => {
    try {
        const response = await apiClient.get(`/api/bic-company-list`);

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        console.error("Error fetching building inspection companies:", error);

        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};

// Get Building control quotation response fields
export const getBuildingControlQuotationResponseFields = async () => {
    try {
        const response = await apiClient.get(`/api/bc-quotation-responce-list`);

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        console.error("Error fetching building control quotation response fields:", error);

        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};

// Get Building control quotations
export const getBuildingControlQuotations = async (role: 'architect' | 'client') => {
    try {
        let endPoint = '';

        if (role === 'architect') {
            endPoint = '/api/bc-quotation-data-arc';
        } else if (role === 'client') {
            endPoint = '/api/bc-quotation-data-client';
        }
        const response = await apiClient.get(endPoint);

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        console.error("Error fetching building control quotations:", error);

        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};

// Get Building control quotation requests
export const getBuildingControlQuotationRequests = async () => {
    try {
        const response = await apiClient.get(`/api/bc-quotation-request-bic`);

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        console.error("Error fetching building control quotation requests:", error);

        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};

// Create building control quotation
export const createBuildingControlQuotationAPI = async (
    project_id: number,
    project_name: string,
    project_address: string,
    share_list: number[],
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/bc-quotation-create-arc`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: JSON.stringify({
                project_id,
                project_name,
                project_address,
                share_list
            }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200, massage: "Quotation created successfully" };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Please check your entered values",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// Create building control quotation response ARC
export const createQuotationARCResponseAPI = async (
    bc_quotation_id: number,
    company_id: number,
    responce_list: BuildingControlQuotationResponsePayload[],
    file_list: File[]
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        /* create form data */
        const formData = new FormData();

        formData.append("bc_quotation_id", String(bc_quotation_id));
        formData.append("company_id", String(company_id));

        if (responce_list && responce_list.length > 0) {
            responce_list.forEach((item, index) => {
                formData.append(`responce_list[${index}][responce_list_id]`, String(item.responce_list_id));
                formData.append(`responce_list[${index}][reply]`, String(item.reply));
            });
        }

        if (file_list && file_list.length > 0) {
            file_list.forEach((file) => {
                formData.append("file_list[]", file);
            });
        }

        const response = await fetch(`${baseURL}/api/bc-quotation-request-responce-add-arc`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: formData,
        });

        const data = await response.json();
        console.log('data', data);

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Please check your entered values",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// Create building control quotation response BIC
export const createQuotationBICResponseAPI = async (
    bc_quotation_id: number,
    responce_list: BuildingControlQuotationResponsePayload[],
    file_list: File[]
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        /* create form data */
        const formData = new FormData();

        formData.append("bc_quotation_id", String(bc_quotation_id));

        if (responce_list && responce_list.length > 0) {
            responce_list.forEach((item, index) => {
                formData.append(`responce_list[${index}][responce_list_id]`, String(item.responce_list_id));
                formData.append(`responce_list[${index}][reply]`, String(item.reply));
            });
        }

        if (file_list && file_list.length > 0) {
            file_list.forEach((file) => {
                formData.append("file_list[]", file);
            });
        }

        const response = await fetch(`${baseURL}/api/bc-quotation-request-responce-bic`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: formData,
        });
        const data = await response.json();
        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Please check your entered values",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// Delete building control quotation response file
export const deleteBuildingControlQuotationResponseFile = async (
    file_id: number
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(
            `${baseURL}/api/bc-quotation-response-file-remove/${file_id}`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    Authorization: FULL_TOKEN,
                },
            }
        );

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// Compare building control quotation
export const compareBuildingControlQuotationAPI = async (
    bc_quotation_id: number,
    comparison: number[]
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/bc-quotation-comparison-client`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: JSON.stringify({
                bc_quotation_id,
                comparison
            }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return {
                status: true,
                statusCode: 200,
                massage: "Quotation compared successfully",
                data: data
            };
        } else if (response.status === 401) {
            return {
                status: false,
                statusCode: 401,
                massage: "Unauthorized"
            };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Error occured while comparing quotation",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// Approve building control quotation
export const approveBuildingControlQuotationAPI = async (
    bc_quotation_id: number,
    company_id: number
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/bc-quotation-approval-client`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: JSON.stringify({
                bc_quotation_id,
                company_id
            }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return {
                status: true,
                statusCode: 200,
                massage: "Quotation approved successfully",
            };
        } else if (response.status === 401) {
            return {
                status: false,
                statusCode: 401,
                massage: "Unauthorized"
            };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Error occured while approving quotation",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};
// ----------------------------------------


// ---------------------------------------- Building control permission
// Get Building control permission list
export const getBuildingControlPermissions = async () => {
    try {
        const response = await apiClient.get(`/api/bc-employee-permission-data`);

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        console.error("Error fetching building control permissions:", error);

        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};

// Add building control projects
export const addBuildingControlProjectsAPI = async (
    list: number[]
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/bc-permission-project-add`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: JSON.stringify({
                list
            }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return {
                status: true,
                statusCode: 200,
                massage: "Project(s) Added successfully",
            };
        } else if (response.status === 401) {
            return {
                status: false,
                statusCode: 401,
                massage: "Unauthorized"
            };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Error occured while adding project(s)",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// Add building control employees
export const addBuildingControlEmployeesAPI = async (
    bcp_project_id: number,
    list: number[]
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/bc-permission-employee-add`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: JSON.stringify({
                bcp_project_id,
                list
            }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return {
                status: true,
                statusCode: 200,
                massage: "Employee(s) Added successfully",
            };
        } else if (response.status === 401) {
            return {
                status: false,
                statusCode: 401,
                massage: "Unauthorized"
            };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Error occured while adding employee(s)",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// Add building control permission
export const addBuildingControlPermissionAPI = async (
    bcp_employee_id: number,
    service_list: BuildingControlPermissionPayload[],
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        /* create form data */
        const formData = new FormData();

        formData.append("bcp_employee_id", String(bcp_employee_id));

        if (service_list && service_list.length > 0) {
            service_list.forEach((item, index) => {
                formData.append(`service_list[${index}][add_default_id]`, String(item.add_default_id));
                formData.append(`service_list[${index}][can_edit]`, String(item.can_edit));
            });
        }

        const response = await fetch(`${baseURL}/api/bc-employee-permission-add`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: formData,
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200, massage: "Permission(s) added successfully" };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Error occured while adding permission(s). Check your credentials and try again.",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// Remove building control projects
export const removeBuildingControlProjectsAPI = async (
    bcp_project_id: number
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/bc-permission-project-remove`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: JSON.stringify({
                bcp_project_id,
            }),
        });

        if (response.status === 200) {
            return {
                status: true,
                statusCode: 200,
                massage: "The project has been successfully removed from the building control permissions.",
            };
        } else if (response.status === 401) {
            return {
                status: false,
                statusCode: 401,
                massage: "Unauthorized"
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// Remove building control employee
export const removeBuildingControlEmployeeAPI = async (
    bcp_employee_id: number
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/bc-permission-employee-remove`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: JSON.stringify({
                bcp_employee_id,
            }),
        });

        if (response.status === 200) {
            return {
                status: true,
                statusCode: 200,
                massage: "The employee has been successfully removed from the building control project.",
            };
        } else if (response.status === 401) {
            return {
                status: false,
                statusCode: 401,
                massage: "Unauthorized"
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};
// ----------------------------------------
